import React from 'react'
import { Button, Card, CardBody, Col, Form, Row } from 'reactstrap'
import styles from './card.module.css'
import Lock from '../../assets/Lock'
import { SunspotLoader } from 'react-awesome-loaders'
import { mockPayment ,getCenterPaymentGatewayList} from 'api/api'
import { connect } from 'react-redux'
import CONFIG from '../../config'
import PaymentForm from './paymentForm'
import MobilePaymentForm from 'components/shared/MobilePaymentForm'


const mapStateToProps = (state) => ({
    token: state?.token,
})

function MockExamLocked(props) {
    let date=new Date()
    const [isLoading, setIsLoading] = React.useState(false)
    const [paymentMethod, setPaymentMethod] = React.useState('paytm')
    const [filteredFormValues, setfilteredFormValues] = React.useState({})
    const [paymentGateways, setPaymentGateways] = React.useState([])
    const { profileData, token } = props

    const handlePaymentMethod = (e) => {
        let name = e.target.value;
        setPaymentMethod(name)
    }

    const handleSubmit = async () => {
        setIsLoading(true)

        // API call
        const mockPrice = await mockPayment(
            token,
            `${CONFIG.MOCK_PAYMENT_API}?payment_mode=${paymentMethod}`,
        ).then((res) => {
            if (res.data.success === 'true') {
                setfilteredFormValues(res.data.data)
                localStorage.setItem(
                    'mock_amount',
                    res.data.data.amount || res.data.data.TXN_AMOUNT,
                )
                return res.data.data.amount || res.data.data.TXN_AMOUNT
            } else {
                console.log('Error occurred: ', res.data.msg)
            }

            setIsLoading(false)
            return 50 // default mock price value
        })
        const examType = profileData.exam_type || 'ANTHE'; // fallback if needed
        const eventName =
        examType === 'AKTHE'
        ? 'AKTHE_db_mock_proceed_to_pay'
        : 'ANTHE_db_mock_proceed_to_pay';
        // web-engage event
        window.webengage.track(eventName, {
            'roll number': profileData.roll_number,
            'exam type': examType,
            class: profileData.class && profileData.class.toString(),
            stream: profileData.stream,
            price: mockPrice && mockPrice.toString(),
            'payment method': paymentMethod,
            Year:date.getFullYear()
        })
    }

React.useEffect(() => {

    const fetchPaymentGateways = async () => {

        try {

            const res = await getCenterPaymentGatewayList(
                token,
                profileData?.branch_code,
                profileData?.exam_type || 'ANTHE'
            )

            console.log('API RESPONSE => ', res?.data)

            if (
                res?.data?.success === true ||
                res?.data?.success === 'true'
            ) {

                // API returns object
                const gatewaysObj = res?.data?.data || {}

                // Convert object to array
                const gateways = Object.keys(gatewaysObj).map((key) => ({

                    payment_gateway: key,
                    label: gatewaysObj[key]?.label,
                    is_primary_account:
                        gatewaysObj[key]?.is_primary_account,

                }))

                console.log('FORMATTED GATEWAYS => ', gateways)

                // Save in state
                setPaymentGateways(gateways)

                // Select default payment gateway
                const primaryGateway = gateways.find(
                    (item) => item?.is_primary_account === true
                )
                if (primaryGateway) {

                    const gateway =
                        primaryGateway?.payment_gateway?.toLowerCase()

                    setPaymentMethod(
                        gateway === 'hdfc'
                            ? 'ccavenue'
                            : gateway
                    )

                } else if (gateways.length > 0) {

                    const gateway =
                        gateways[0]?.payment_gateway?.toLowerCase()

                    setPaymentMethod(
                        gateway === 'hdfc'
                            ? 'ccavenue'
                            : gateway
                    )
                }
            }

        } catch (err) {

            console.log('Payment gateway API error => ', err)
        }
    }

    if (profileData?.branch_code && profileData.exam_type == "ANTHE") {

        fetchPaymentGateways()
    }

}, [profileData, token])
    return (
        <>
            {profileData.exam_type == "ANTHE" && <Card className={`${styles.lockModal} border-0 w-100 h-100`}>
                <CardBody className="p-3 d-lg-flex">
                    <Row className="justify-content-xs-between my-1 col-xs-12 col-lg-7 col-xl-8 my-auto">
                        <Col xs={3} xl={2} className="align-self-baseline d-flex">
                            <Button
                                className={`${styles.modalLockBtn} w-11 font-size-xxl py-3 py-lg-4 fw-bold border-white rounded-1`}
                                style={{ padding: 'initial' }}
                            >
                                <Lock fill={'white'} width="40%" height="40" />
                            </Button>
                        </Col>
                        <Col xs={9} md={7} className="p-1">
                            <p className="font-size-md text-white fw-bold mb-2">
                            {profileData?.exam_type === 'AKTHE' ? 'AKTHE MOCK TEST PAPER' : 'ANTHE MOCK TEST PAPER'}
                            </p>
                            <p className="font-size-sm font-size-md-md font-size-xl-lg font-size-xl-xxl m-0 fw-lighter text-white">
                                Set of 4 Mock Test Papers
                            </p>
                            <p className="font-size-xs font-size-md-xs font-size-xl-md fw-normal text-white">
                                Higher Chances of Getting Scholarship
                            </p>
                        </Col>
                    </Row>
                    <Row
                        className={`${styles.paymentFormContainer} d-flex align-items-center col-xs-20 col-lg-5 col-xl-4 h-xl-75 mx-1 py-4 my-auto rounded-8px`}
                    >
                        <Form
                            onSubmit={(e) => {
                                e.preventDefault()
                                handleSubmit()
                            }}
                        >
                            {/* <Row className="d-flex justify-content-around"> */}
                            <Row className="d-flex flex-column align-items-start gap-2">
                                <MobilePaymentForm
                                    paymentMethod={paymentMethod}
                                    handlePaymentMethod={handlePaymentMethod}
                                    paymentGateways={paymentGateways}
                                />
                            </Row>

                            <Button
                                type="submit"
                                className={`w-100 bg-aqua border-0 font-size-md fw-lighter mt-4`}
                            >
                                {isLoading ? (
                                    <SunspotLoader
                                        gradientColors={['#4039d4', '#E0E7FF']}
                                        size={'10px'}
                                        desktopSize={'10px'}
                                        className="m-auto"
                                    />
                                ) : (
                                    'Buy now at just ₹50'
                                )}
                            </Button>
                        </Form>

                        {Object.keys(filteredFormValues).length > 0 && (
                            <PaymentForm filteredFormValues={filteredFormValues} />
                        )}
                    </Row>
                </CardBody>
            </Card>}
        </>
    )
}

export default connect(mapStateToProps)(MockExamLocked)
